import {
  BrandMembership,
  PatientBrandMembershipFragment,
  useGetPatientQuery,
} from '@pm/graphql';
import { BrandId } from '../types';

/**
 * Determines whether a user has a membership matching the provided brand
 */
export const hasMembership = (
  memberships: Pick<PatientBrandMembershipFragment, 'brand'>[],
  brandId: BrandId,
) => {
  return memberships.some((membership) =>
    isBrandMember(brandId, membership.brand),
  );
};

export const isBrandMember = (
  brandId: BrandId,
  brand?: Pick<BrandMembership, 'id'> | null,
) => brand?.id === brandId;

export const isScreenedOut = (
  membership?: Pick<PatientBrandMembershipFragment, 'screenedOutStep'> | null,
) => {
  return !!membership?.screenedOutStep;
};

/**
 * Custom hook to determine if a patient is a Frida patient
 * Only fetches patient data when userId is provided
 */
export const useIsFridaPatient = (userId?: string) => {
  const { data: patientData } = useGetPatientQuery({
    variables: {
      id: userId || '',
    },
    skip: !userId,
  });

  return hasMembership(patientData?.user?.brands || [], BrandId.Frida);
};
